module.exports = __webpack_public_path__ + "img/JXZWSZ_logo_name.342ab459.png";